import { gql } from "@apollo/client";

import { linkedCaseElementFragment } from "./LinkedCaseElementFragment";
import { linkedCasePropertyValueFragment } from "./LinkedCasePropertyValueFragment";

export const linkedCaseFragment = gql`
  fragment LinkedCaseFragment on Case {
    id
    alertStatus
    configurableType {
      code
      name
    }

    snapshotCreation
    typeCode
    lastScore
    properties {
      ...LinkedCasePropertyValueFragment
    }
    elements {
      ...LinkedCaseElementFragment
      elements {
        ...LinkedCaseElementFragment
      }
    }
  }
  ${linkedCaseElementFragment}
  ${linkedCasePropertyValueFragment}
`;
